import Image from 'next/image';
import { getReadableImageUrl } from "@/lib/directus";
import { sanitizeHTML } from "@/lib/utils";

interface RightTextLeftImageData {
  heading?: {
    text?: string;
    title?: string;
  };
  text?: {
    text?: string;
  };
  image?: {
    alt: string;
    image_file: {
      image: {
        id: string;
        filename_download: string;
      };
    };
  };
}

export const fields = [
  "heading.text",
  "heading.title",

  // text
  "text.text",
  
  // image
  "image.alt",
  "image.image_file.image.id",
  "image.image_file.image.filename_download",
] as const;

interface RightTextLeftImageProps {
  data?: RightTextLeftImageData;
}

export default function RightTextLeftImage({ data }: RightTextLeftImageProps) {
  if (!data) return null;
  
  const imageUrl = data.image?.image_file?.image?.id 
    ? getReadableImageUrl(data.image.image_file.image.id, data.image.image_file.image.filename_download) 
    : '/images/dr-bader-examines-patient.png';
  
  const imageAlt = data.image?.alt || 'Rhinoplasty Procedure';
  const headingText = data.heading?.text || data.heading?.title;
  const Wrapper = headingText ? 'section' : 'div';
  
  return (
    <Wrapper className="w-full bg-white">
      <div className="max-w-screen-2xl mx-auto px-8 py-8 md:py-16">
        <div className="flex flex-col md:flex-row gap-8 md:gap-16 md:items-center">
          <div className="w-full md:w-1/2 relative aspect-[844/780] bg-dark/40 rounded-lg">
            <Image
              src={imageUrl}
              alt={imageAlt}
              fill
              className="object-cover rounded-lg"
              sizes="(max-width: 768px) 100vw, 50vw"
              quality={90}
            />
          </div>
          <div className="md:w-1/2">
            {(data.heading?.text || data.heading?.title) && (
              <h2 className="text-[2rem] font-essonnes font-light leading-tight md:text-5xl lg:text-[3.375rem] text-primary mb-8" dangerouslySetInnerHTML={sanitizeHTML(data.heading?.text || data.heading?.title || '')} />
            )}
           
            {data.text?.text && (
              <div 
                className="text-[1rem] font-normal leading-normal md:text-xl text-primary font-greycliff md:leading-relaxed
                  [&>ul]:list-disc [&>ul]:pl-6 [&>ul]:pb-4
                  [&>ul>li]:mb-2 [&>ul>li:last-child]:mb-0
                  [&>ol]:list-decimal [&>ol]:pl-6
                  [&>ol>li]:mb-2 [&>ol>li:last-child]:mb-0
                  [&>p]:mb-4 [&>p:last-child]:mb-0
                  [&>*]:text-[1rem] [&>*]:font-normal [&>*]:leading-normal md:[&>*]:text-xl
                  [&_a]:underline [&_a]:transition-all [&_a:hover]:no-underline
                  [&>h3]:text-[1.5rem] [&>h3]:font-greycliff [&>h3]:font-medium [&>h3]:text-primary [&>h3]:leading-[2rem] [&>h3]:tracking-tight [&>h3]:mb-4"
                dangerouslySetInnerHTML={sanitizeHTML(data.text.text)}
              />
            )}
            {!data.text?.text}
          </div>
        </div>
      </div>
    </Wrapper>
  );
} 
